import { render } from "./SelectRoom.vue?vue&type=template&id=35d25307"
import script from "./SelectRoom.vue?vue&type=script&lang=js"
export * from "./SelectRoom.vue?vue&type=script&lang=js"

import "./SelectRoom.vue?vue&type=style&index=0&id=35d25307&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__